<template>
<div class="container-1">
    <el-popover placement="bottom-start" v-model="visible" trigger="manual" :width="width">
        <ul class="associate-list">
                <!-- <li class="associate-item" v-if="inputContent">{{inputContent}}</li>     -->
                <li class="associate-item" v-for="(item,index) in associateWords" :key="index" 
                    @click="selectedLi(index)">{{item.label}}</li>  
        </ul> 
        <template v-slot:reference>
            <div>
                <el-input v-model="valueModel" class="search" size="small" :style="{width:width+'px'}" 
                    @keyup.native="input" 
                    @focus="onFocus" 
                    @input="setValue" 
                    @blur="visible=false"
                    :placeholder="placeholder"
                    :disabled="disabled"
                    >
                </el-input>
            </div>
        </template>
    </el-popover>
    
    
</div>
    
</template>
<script>
export default {
    name:"customInput",
    data(){
        return {
            valueModel:"",
            showList:false,
            visible:false,
            associateWords:[],
            focusIndex:0,
            inputContent:'',
            valueMap:{"无结果":-99999}
        }
    },
    props:{
        value:{
            type:String,
            default:''
        },
        disabled:{
            type:Boolean,
            default:false
        },
        placeholder:{
            type:String,
            default:''

        },
        width:{
            type:String,
            default:''
        }
    },
    watch:{
        value:{
            handler(v){
                this.valueModel = _.cloneDeep(v)
            }
        }
    },
    mounted(){
        this.clickBlank()
    },
    methods:{
        onFocus(){
            this.associateWords = [{label:"无结果",value:-99999}] 
            this.visible = true
        },
        setValue(value){
            this.valueModel = this.$tool.allowNumber(value, {max: 100})
            this.$emit('input',this.valueModel)

        },
        input (e) {  
            //keyup事件的event    
            e = e || window.event      
            //this.showList = true
            this.visible = true
            // 按“↑” 键     
            if (e.keyCode === 38) {        
                this.focusIndex--        
                this.selectedLi()      
            } else if (e.keyCode === 40) {        
                // 按“↓”,数组下标从0开始,list的[0]项内容为用户输入内容，不显示，从[1]项开始显示  
                this.selectedLi()      
                this.focusIndex++        
                      
            } else if (e.keyCode === 13) {        
                // 按“Enter”调用搜索函数        
                //----向后台发送搜索请求     
                this.associateWords = []
                this.visible = false
                 //this.$emit('input',this.valueModel)
            } else {        
                // 用户继续输入时，将inputContent置空----非常重要的一步       
                this.inputContent = ''        
                this.focusIndex = 0        
                // 搜索联想内容        
                //this.getAssociateWords() //----向后台请求相关联想词列表       
                this.clearSelected()      
            }    
        },
        selectedLi (hoverIndex) {      
            // 当inputContent内容为空时，记录下搜索框中用户输入的内容，作为associate-item的第一项      
            if (this.inputContent === '') {        
            this.inputContent = ''      
            }      
            let associateList = document.getElementsByClassName('associate-item')      
            // 移除已添加的.selected样式      
            for (var i = 0; i < associateList.length; i++) {        
                associateList[i].classList.remove('selected')      
            }      
            if (hoverIndex !== undefined) {        
                this.focusIndex = hoverIndex      
            }
            // 一直按向下键超出联想内容li长度时，应回到联想内容第一个      
            this.focusIndex = (this.focusIndex + associateList.length) % associateList.length      
            // 为选中的li添加.selected样式      
            let selectedOne = associateList[this.focusIndex]      
            this.valueModel = selectedOne.textContent
            //this.valueModel = this.valueMap[selectedOne.textContent]
            selectedOne.classList.add('selected')  
            this.visible = false  
            this.$emit('input',this.valueModel)
        },
        clearSelected () {      
            let associateList = document.getElementsByClassName('associate-item')      
            // 移除已添加的.selected样式      
            for (var i = 1; i < associateList.length; i++) {        
                associateList[i].classList.remove('selected')      
            }    
        },
        clickBlank(){
            // 点击input输入框以外的位置时 隐藏联想词列表    
            document.body.addEventListener('click', e => {      
                if (e.target.nodeName === 'INPUT') {        
                    //this.showList = true      
                } else {        
                    //this.showList = false
                    this.visible = false
                }    
            })
        }
    }
    
}
</script>
<style lang="less" scoped>
.container-1{
    display: inline-block;
    padding:0
}
.search{
    width:100%
}
.associate-list{
    width:100%;
    overflow-y: scroll;
    max-height: 100px;
    background-color: #fff;
}
.associate-item{
    padding:4px 12px;
    color:#000
}

.associate-item:hover{
    background-color: #EAF3FF;
    cursor: pointer;
}
.selected{
    background-color: #EAF3FF;
}
</style>